module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-1194w.e0fd731d.jpg";